/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Item ligero de listado de candidaturas [P_E_05]
 * @export
 * @interface CompanyApplicationItem
 */
export interface CompanyApplicationItem {
    /**
     * 
     * @type {number}
     * @memberof CompanyApplicationItem
     */
    id?: number;
    /**
     * applied, accepted, selected, discarded
     * @type {string}
     * @memberof CompanyApplicationItem
     */
    status?: string;
    /**
     * fecha de inscripcion
     * @type {string}
     * @memberof CompanyApplicationItem
     */
    applicationDate?: string;
    /**
     * Nombre del candidato
     * @type {string}
     * @memberof CompanyApplicationItem
     */
    name?: string;
    /**
     * Edad del candidato
     * @type {number}
     * @memberof CompanyApplicationItem
     */
    age?: number;
    /**
     * Nota de las respuestas, -1 killer
     * @type {number}
     * @memberof CompanyApplicationItem
     */
    killerGrade?: number;
    /**
     * Flag indicando si las respuestas tienen puntuacion
     * @type {boolean}
     * @memberof CompanyApplicationItem
     */
    hasKillerGrade?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyApplicationItem
     */
    academicProgram?: number;
    /**
     * Porcentaje de academic program finalizado. Averiguar como calcularlo
     * @type {number}
     * @memberof CompanyApplicationItem
     */
    academicProgramPercent?: number;
    /**
     * Especifica si hay preguntas
     * @type {boolean}
     * @memberof CompanyApplicationItem
     */
    hasQuestions?: boolean;
}

export function CompanyApplicationItemFromJSON(json: any): CompanyApplicationItem {
    return CompanyApplicationItemFromJSONTyped(json, false);
}

export function CompanyApplicationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyApplicationItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'applicationDate': !exists(json, 'application_date') ? undefined : json['application_date'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'age': !exists(json, 'age') ? undefined : json['age'],
        'killerGrade': !exists(json, 'killer_grade') ? undefined : json['killer_grade'],
        'hasKillerGrade': !exists(json, 'has_killer_grade') ? undefined : json['has_killer_grade'],
        'academicProgram': !exists(json, 'academic_program') ? undefined : json['academic_program'],
        'academicProgramPercent': !exists(json, 'academic_program_percent') ? undefined : json['academic_program_percent'],
        'hasQuestions': !exists(json, 'has_questions') ? undefined : json['has_questions'],
    };
}

export function CompanyApplicationItemToJSON(value?: CompanyApplicationItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
        'application_date': value.applicationDate,
        'name': value.name,
        'age': value.age,
        'killer_grade': value.killerGrade,
        'has_killer_grade': value.hasKillerGrade,
        'academic_program': value.academicProgram,
        'academic_program_percent': value.academicProgramPercent,
        'has_questions': value.hasQuestions,
    };
}


